"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _InputGroup = _interopRequireDefault(require("@insided/shared/uikit/InputGroup"));

var SSIHeader = function SSIHeader(_ref) {
  var url = _ref.url,
      _onChange = _ref.onChange;
  return (0, _preact.h)(_InputGroup.default, {
    title: "SSI URL",
    type: "text",
    onChange: function onChange(e) {
      return _onChange({
        url: e.target.value
      });
    },
    value: url
  });
};

var _default = SSIHeader;
exports.default = _default;